var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c('div',[_c('van-loading',{attrs:{"color":"#8A8A8A","size":"16px"}})],1),_c('div',{staticClass:"loadingText"},[_vm._v(_vm._s(_vm.loadingText==0?'调取支付中...': '加载中...'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }